<div class="dialoghead">
    <h1 class="mat-mdc-dialog-title">Hey !</h1>
    <div class="modal-textwrapper">
        <p>confirmation with</p>
        <p><strong>Email:</strong>  {{modaldata.markasObj.email}} <strong>Name:</strong>  {{modaldata.markasObj.name}}</p>
    </div>
    
    <div class="mat-mdc-dialog-actions new_button_wrapper">
        <button mat-button class="" (click)="sendMail()">Yes</button>
        <button mat-button class="" (click)="closeModal()">No</button>
    </div>
</div>

<span mat-button mat-dialog-close class="close-btn-modal material-icons">close</span>